import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { accessInputFromRedux } from '@/abilities/accessInput';
import { useAccessInputFromQuery } from '@/abilities/useAccessInputFromQuery';
import { companyWorkspaceAccess } from '@/abilities/companyWorkspace/access';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';
import { companyRoleSelector } from '@/domain/env/sessionRoleSelectors';
import { useCompanyCapabilities } from '@/domain/companies/queries/capabilities';

export const useCompanyWorkspaceAccess = () => {
  const companyId = useSelector(currentCompanyIdSelector);
  const role = useSelector(companyRoleSelector);
  const capabilities = useAccessInputFromQuery(useCompanyCapabilities(companyId));
  return useMemo(
    () =>
      companyWorkspaceAccess({
        role: accessInputFromRedux(role),
        capabilities,
      }),
    [role, capabilities],
  );
};
